/**
 * Single-schema mode: one database, region_id row scoping (replaces per-region DB connections).
 * On the neo branch this defaults ON unless explicitly disabled.
 */
const env = import.meta.env.VITE_SINGLE_SCHEMA_ENABLED

export const SINGLE_SCHEMA_ENABLED =
  env === 'false' || env === '0' ? false : env === 'true' || env === '1' || env === undefined

/** Default connection name when single-schema is enabled (informational). */
export const SINGLE_SCHEMA_CONNECTION =
  import.meta.env.VITE_SINGLE_SCHEMA_CONNECTION || 'mysql'

/** Route names hidden when single-schema consolidates fragmented list pages. */
export const SINGLE_SCHEMA_DEPRECATED_ROUTE_NAMES = [
  'go-metro-vehicles',
  'aeversa-vehicles',
  'uber-deployed-drivers',
  'valt-v2-valt-vehicles',
  'valt-v2-valt-drivers',
  'valt-v2-uber-vehicles',
  'uteh-vehicles',
  'bikes',
  'valt-v2-drivers',
  'valt-v2-vehicles',
  'fleet-vehicles-menu',
] as const
